"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/TableHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);








/* The campaign table's variable headers, in the shared table's head. */
const VariableHeaders = ({ columns, onMoveColumn }) => {
  const [dragged, setDragged] = _react.useState(null)
  const [over, setOver] = _react.useState(null)
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  columns.map(c => (
        _react2.default.createElement('th', {
          key: c.name,
          draggable: !!onMoveColumn,
          title: onMoveColumn ? 'Drag to reorder' : undefined,
          onDragStart: e => {
            setDragged(c.name)
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData('text/plain', c.name)
          },
          onDragOver: e => { if (dragged) { e.preventDefault(); setOver(c.name) } },
          onDragLeave: () => setOver(o => o === c.name ? null : o),
          onDrop: e => {
            e.preventDefault()
            if (dragged && onMoveColumn) onMoveColumn(dragged, c.name)
            setDragged(null)
            setOver(null)
          },
          onDragEnd: () => { setDragged(null); setOver(null) },
          className: _classBuilder2.default.call(void 0, 
            'campaign--table--col-variable',
            onMoveColumn && 'campaign--table--col-variable--draggable',
            over === c.name && dragged !== c.name && 'campaign--table--col-variable--over',
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}

          ,  c.name 
        )
      ))
    )
  )
}

exports. default = VariableHeaders
